import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookieConsent", "declined");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-content">
        <div className="cookie-text">
          <h3>Χρήση Cookies</h3>
          <p>
            Χρησιμοποιούμε cookies για να βελτιώσουμε την εμπειρία σας στον
            ιστότοπό μας, να αναλύσουμε την επισκεψιμότητα και να προσαρμόσουμε
            το περιεχόμενο στις ανάγκες σας.
          </p>
          <p>
            Για περισσότερες πληροφορίες, διαβάστε την{" "}
            <Link to="/privacy-policy">Πολιτική Απορρήτου</Link> μας.
          </p>
        </div>
        <div className="cookie-buttons">
          <button
            onClick={handleAccept}
            className="cookie-btn cookie-btn-accept"
          >
            Αποδοχή Όλων
          </button>

          <button
            onClick={handleDecline}
            className="cookie-btn cookie-btn-decline"
          >
            Απόρριψη
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
